/* eslint-disable indent, no-param-reassign,no-plusplus, no-unused-vars */
import axios from 'axios';
import groupBy from 'lodash/groupBy';
import cacheAxios from '../../util/cacheAxios';

const companyIndexesAxios = axios.create();
const cache = new Map();
cacheAxios(companyIndexesAxios, cache);
companyIndexesAxios.interceptors.response.use(response => response,
  (error) => {
    if (error && error.response && error.response.status === 401) {
      setTimeout(() => {
        window.location.href = '/sign/in?source=/aims';
      }, 500);
    }
  });

export default {
  state: {
    costPressures: {},
    salaryCostPressures: {},
    revMomentums: {},
    expansionThreats: {},
    customersNote: '',
    suppliersNote: '',
    competitorsNote: '',
    disruptorsNote: '',
  },
  mutations: {
    setSalaryCostPressures(state, indexes) {
      state.salaryCostPressures = indexes;
    },
    setCostPressures(state, indexes) {
      state.costPressures = indexes;
    },
    setRevMomentums(state, indexes) {
      state.revMomentums = indexes;
    },
    setExpansionThreats(state, indexes) {
      state.expansionThreats = indexes;
    },
    setNote(state, {
      module,
      note,
    }) {
      switch (module) {
      case 'CompetitorsMatrix':
        state.competitorsNote = note;
        break;
      case 'CustomersMatrix':
        state.customersNote = note;
        break;
      case 'SuppliersMatrix':
        state.suppliersNote = note;
        break;
      case 'Disruptors':
        state.disruptorsNote = note;
        break;
      default:
      }
    },
  },
  actions: {
    getAllSalaryCostPressures({
      commit,
    }) {
      companyIndexesAxios.get('/aims/api/companyIndexes/salaryCostPressures')
        .then(res => commit('setSalaryCostPressures', res.data));
    },
    getAllCostPressures({
      commit,
    }) {
      companyIndexesAxios.get('/aims/api/companyIndexes/costPressures')
        .then(res => commit('setCostPressures', res.data));
    },
    getAllRevMomentums({
      commit,
    }) {
      companyIndexesAxios.get('/aims/api/companyIndexes/revMomentums')
        .then(res => commit('setRevMomentums', res.data));
    },
    getAllExpansionThreats({
      commit,
    }) {
      companyIndexesAxios.get('/aims/api/companyIndexes/expansionThreats')
        .then(res => commit('setExpansionThreats', res.data));
    },
    getDisruptorsNote({
      commit,
      rootState,
    }) {
      companyIndexesAxios.get(`/aims/api/notes/${rootState.currentUser.userid}/Disruptors`)
        .then(res => commit('setNote', res.data));
    },
    getCustomersNote({
      commit,
      rootState,
    }) {
      companyIndexesAxios.get(`/aims/api/notes/${rootState.currentUser.userid}/CustomersMatrix`)
        .then(res => commit('setNote', res.data));
    },
    getSuppliersNote({
      commit,
      rootState,
    }) {
      companyIndexesAxios.get(`/aims/api/notes/${rootState.currentUser.userid}/SuppliersMatrix`)
        .then(res => commit('setNote', res.data));
    },
    getCompetitorsNote({
      commit,
      rootState,
    }) {
      companyIndexesAxios.get(`/aims/api/notes/${rootState.currentUser.userid}/CompetitorsMatrix`)
        .then(res => commit('setNote', res.data));
    },
    saveNote(context, note) {
      companyIndexesAxios.post('/aims/api/notes', note);
      // .then(res => console.log(res));
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/companyIndexesModule.js